<script setup>
//region Imports
import { ref, onMounted, reactive } from 'vue'
//endregion
//region Methods
const readData = () => JSON.parse(localStorage.getItem('tc-claim-data'))
const readSelectedItems = () => JSON.parse(localStorage.getItem('tc-claim-selected-items'))

const clickToContinue = () => {
  location.replace('#/claim/details')
}
//endregion
//region Variables
const data = reactive(readData() ?? {})
const items = reactive(readSelectedItems() ?? [])
//endregion
//region Lifecycle
onMounted(() => {

})
//endregion
</script>

<template>

<!--
<figure class="w-full h-[305px] overflow-hidden bg-no-repeat bg-right bg-cover"
          style="background-image: url(https://cdn.shopify.com/s/files/1/0067/9532/9609/files/DSC01071.png?v=1713213218);">&nbsp;</figure>

-->

  <main class="lg:max-w-[420px] mx-auto my-[28px] px-[20px] lg:px-[40px]">

    <figure>
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="49" viewBox="0 0 25 49" fill="none">
        <path
            d="M10.1231 39.5608V10.4135C10.1533 10.413 10.1817 10.4068 10.2113 10.4068C16.407 10.4068 20.5372 16.0344 21.9139 24.1737C25.8018 22.3518 25.6789 18.3835 23.4113 15.6703C20.497 12.1477 15.7999 10.1231 10.2113 10.1231C10.1812 10.1231 10.1533 10.1265 10.1231 10.1265V0H9.83937C9.83937 8.86811 5.10204 10.1231 0 10.1231V10.4068H5.26289V40.2489C5.26289 44.2183 8.01638 48.5909 14.3745 48.5909C18.5461 48.5909 21.3392 45.3118 22.4322 43.4073L22.1898 43.2861C21.0158 45.3118 18.4645 47.7 15.1442 47.7C11.0139 47.7 10.1231 44.3395 10.1231 39.5608Z"
            fill="#2E1319"/>
      </svg>
    </figure>

    <h1 class="text-tc-title font-bold font-minionpro text-tc-black my-[30px] max-w-[216px]">Thank you for submitting a claim!</h1>

    <p class="leading-normal text-tc-maroon font-avenir text-tc-xl font-normal tracking-wide mb-[30px]"
    >We are actively reviewing your issue, and will provide an update as soon as our review is complete.</p>

    <button type="submit"
        @click="clickToContinue"
        class="text-center font-avenir text-tc-xl font-normal tracking-wide border py-2.5 px-8 bg-tc-maroon text-white border-gray-400 w-full"
    >Close
    </button>

  </main>

</template>

<style scoped>
</style>